import { DocumentIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { byteConverter, formatDate3 } from '@/utils';

export type RecentFile = {
  contentType: string;
  createdAt: string;
  key: string;
  name: string;
  size: number;
};

type RecentUploadsProps = {
  recentFiles: RecentFile[] | undefined;
  onRemove?: (index: number, file: RecentFile) => void;
};

export function RecentUploads({ recentFiles, onRemove }: RecentUploadsProps) {
  if (!recentFiles || !recentFiles.length) {
    return null;
  }

  return (
    <div className='col-span-2 space-y-1 mt-2'>
      <p>Recent Uploads</p>
      <ul>
        {recentFiles.map((file, index) => (
          <li key={file.createdAt} className='flex justify-between items-center border rounded-md p-2'>
            <div className='flex gap-2 items-center overflow-hidden mr-2'>
              <DocumentIcon className='w-7 h-7 flex-none' />
              <div className='flex flex-col overflow-hidden'>
                <h5 className='text-sm capitalize truncate'>{file.name}</h5>
                <div className='flex text-xs gap-5 text-neutralColor-normal'>
                  <span>Date: {formatDate3(file.createdAt)}</span>
                  <span>Size: {byteConverter(file.size, 2)}</span>
                </div>
              </div>
            </div>
            <XCircleIcon
              className='w-4 h-4 hover:text-tertiaryColor-normal cursor-pointer'
              onClick={() => {
                onRemove?.(index, file);
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
